import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'user-status',
  templateUrl: './user-status.component.html',
  styleUrls: ['./user-status.component.scss'],
})
export class UserStatusComponent implements ICellRendererAngularComp {
  refresh;
  status: string;
  private params: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.status = this.params?.resourceId;
  }
}
